import * as React from "react";

import { getRoutePath, redirectToRoutePath, sectionClasses } from "../common/Utils";
import { QuoteFormEventType } from "../../../Common/QuoteFormEventTracking/QuoteFormEventType";
import { WizardStep } from "../common/WizardStep";

import { IStepProps } from "../interfaces/IStepProps";
import { IStepState } from "../interfaces/IStepState";
import { IAutoWizardModel } from "../interfaces/IAutoWizardModel";

import { LogStep } from "../../../Common/QuoteFormEventTracking/LogStep";

declare const supportAdditionalDriver: boolean;

interface IAdditionalDriverNameStepState extends IStepState {
    firstName?: string;
    lastName?: string;
    firstNameError?: string;
    lastNameError?: string;
}

export class AdditionalDriverNameStep extends React.Component<IStepProps, IAdditionalDriverNameStepState> {

    continueButton: any;

    state: IAdditionalDriverNameStepState;

    constructor(props: IStepProps) {
        super(props);

        this.handleOnClick = this.handleOnClick.bind(this);

        this.handleOnChangeFirstName = this.handleOnChangeFirstName.bind(this);
        this.handleOnChangeLastName = this.handleOnChangeLastName.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.continueButton = React.createRef();

        this.state = {
            firstName: this.props.model.additionalDriver.firstName,
            lastName: this.props.model.additionalDriver.lastName,
            firstNameError: "",
            lastNameError: "",
            redirectPath: "",
            goToNextStep: false
        }
    }

    isNameValid(name: string): boolean {
        if (0 === name.length) {
            return false;
        }

        if (name.length < 2 || name.length > 24) {
            return false;
        }

        // Validate firstname and lastname contain at least one alphabet
        return /[a-zA-Z]+/.test(name);
    }


    handleOnClick(event: React.MouseEvent<HTMLAnchorElement>): void {
        let firstNameError = "";
        let lastNameError = "";

        if (!this.isNameValid(this.state.firstName)) {
            firstNameError = "Please enter a valid first name";
        }

        if (!this.isNameValid(this.state.lastName)) {
            lastNameError = "Please enter a valid last name";
        }


        if (firstNameError.length > 0 ||
            lastNameError.length > 0) {

            this.setState({
                firstNameError: firstNameError,
                lastNameError: lastNameError,
            });

            return;
        }

        let model: IAutoWizardModel = JSON.parse(JSON.stringify(this.props.model));

        model.additionalDriver.firstName = this.state.firstName;
        model.additionalDriver.lastName = this.state.lastName;

        this.props.onUpdateModel(model);

        const routePath = getRoutePath(WizardStep.CONTACT_INFO_ADDRESS);

        this.setState({ redirectPath: routePath, goToNextStep: true });
    }

    handleOnBlur(event: React.FocusEvent<HTMLInputElement>): void {

    }

    handleOnChangeFirstName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({ firstName: event.target.value });
    }

    handleOnChangeLastName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({ lastName: event.target.value });
    }

    handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>): void {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.continueButton.current.click();
        }
    }

    render(): JSX.Element {
        if (this.state.goToNextStep) {
            redirectToRoutePath(this.state.redirectPath);
            return null;
        }

        const sectionStyle = {
            display: 'block'
        }

        const firstNameError = this.state.firstNameError.length > 0 ? <span id="AdditionalDriverName_FirstName_Error" className="field-invalid-text">{this.state.firstNameError}</span> : "";
        const lastNameError = this.state.lastNameError.length > 0 ? <span id="AdditionalDriverName_LastName_Error" className="field-invalid-text">{this.state.lastNameError}</span> : "";
        
        return <React.Fragment>
            <LogStep lastStep="AdditionalDriverBirthDay" nextStep="ContactInfoAddress" stepNumber={QuoteFormEventType.AdditionalDriverNameStep} sectionName="AdditionalDriverName" wizardName="AutoWizard" logStep={true} />
            <div id="AdditionalDriverNameStep" className={sectionClasses} style={sectionStyle}>
                <div id="AdditionalDriverName">
                    <div className="first-name">
                        {firstNameError}
                        <input type="text" id="AdditionalDriverName_FirstName" onKeyDown={this.handleKeyDown} placeholder="First Name" maxLength={40} onChange={this.handleOnChangeFirstName} value={this.state.firstName} />
                    </div>
                    <div className="last-name">
                        {lastNameError}
                        <input type="text" id="AdditionalDriverName_LastName" onKeyDown={this.handleKeyDown} placeholder="Last Name" maxLength={40} onChange={this.handleOnChangeLastName} value={this.state.lastName} />
                    </div>
                    <a id="AdditionalDriverName_Continue" className="continueButton" onClick={this.handleOnClick} ref={this.continueButton}>CONTINUE</a>
                </div>
            </div>
        </React.Fragment>;
    }
}